import { JoyachessItemNo } from '../../constants/EntertainmentGames/joyachessItemNo';
import { MultiplayerGameType } from '../../constants/EntertainmentGames/multiplayerGame';
import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { AttachmentImage, I18n, UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

export enum MultiplayerGameMode {
  Classic = 'classic',
  Joyajoy = 'joyajoy',
}

export enum MultiplayerGameAudienceType {
  Public = 'public',
  Followers = 'followers',
  Members = 'members',
}

export type I18nGameInfo = I18n<{
  title: string;
}>;

export interface PieceDesigns {
  [key: string]: {
    itemId: JoyachessItemNo;
    text?: string;
    icon?: boolean;
    image?: {
      type: 'image';
      fileId: Uuid;
    };
  };
}

export interface BoardDesign {
  opacity: number;
  icon: boolean;
  itemId: string;
  image?: {
    type: 'image';
    fileId: Uuid;
  };
}

export type MultiplayerGameJson<T = number> = {
  multiplayerGameId: Uuid;
  gameCollectionId: Uuid;
  classroomId: Uuid;
  createdBy: UserId;
  createdAt: T;
  audience: MultiplayerGameAudienceType;
  lastModifiedAt: T;
  gameType: MultiplayerGameType;
  i18nGameInfo: I18nGameInfo | undefined;
  teams: number;
  playersInTeam: number;
  mode: MultiplayerGameMode;
  thinkingTimeLimit: number; //in sec
  responseTimeLimit: number; //in sec
  gameData: {
    boardDesign: BoardDesign;
    boardSize: number;
    pieceDesigns: PieceDesigns;
    winCombination: string[];
  };
  background: AttachmentImage | null;
  moveFee: {
    token: number;
  };
};

export class MultiplayerGame
  extends RepositoryElement
  implements MultiplayerGameJson<Date>
{
  readonly multiplayerGameId!: Uuid;
  gameCollectionId!: Uuid;
  classroomId!: Uuid;
  createdBy!: UserId;
  createdAt!: Date;
  audience!: MultiplayerGameAudienceType;
  lastModifiedAt!: Date;
  gameType!: MultiplayerGameType;
  i18nGameInfo!: I18nGameInfo | undefined;
  teams!: number;
  playersInTeam!: number;
  mode!: MultiplayerGameMode;
  thinkingTimeLimit!: number; // in sec
  responseTimeLimit!: number; // in sec
  gameData!: {
    boardDesign: BoardDesign;
    boardSize: number;
    pieceDesigns: PieceDesigns;
    winCombination: string[];
  };
  background!: AttachmentImage | null;
  moveFee!: {
    token: number;
  };

  constructor(spaceTeam: MultiplayerGameJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(spaceTeam));
  }

  id() {
    return this.multiplayerGameId;
  }

  toJSON(): MultiplayerGameJson<number> {
    // Convert the class instance back to a JSON object
    // The type assertion should match the generic type of the interface
    return deepTransformDate(this) as unknown as MultiplayerGameJson<number>;
  }
}
